import { render } from "./FullPageTermsForm.vue?vue&type=template&id=b1003132"
import script from "./FullPageTermsForm.vue?vue&type=script&lang=js"
export * from "./FullPageTermsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__